import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36d856a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-dropdown" }
const _hoisted_2 = { class: "item-body multiselect-width col-lg-auto col-md-auto col-sm-12 ps-0 pe-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-placeholder-gray" }, "Type to search", -1))
const _hoisted_4 = {
  key: 1,
  class: "row mt-1 item-validation-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["item-label", {'row': !_ctx.isSmallScreen}])
    }, _toDisplayString(_ctx.title), 3),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item-label-alt pt-1 mb-2", {'row': !_ctx.isSmallScreen}])
        }, _toDisplayString(_ctx.description), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass({'row': !_ctx.isSmallScreen})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_VueMultiselect, {
          modelValue: _ctx.selectedOption,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOption) = $event)),
          options: _ctx.filteredOptions,
          "close-on-select": !_ctx.multiselect,
          "preserve-search": _ctx.multiselect,
          "clear-on-select": true,
          placeholder: _ctx.placeholderValue,
          multiple: _ctx.multiselect,
          "select-label": "",
          "deselect-label": "",
          "internal-search": false,
          "track-by": "text",
          label: "text",
          disabled: _ctx.isDisabled,
          class: _normalizeClass(["custom-multiselect", { 'multiselect-validation-error': _ctx.validationError }]),
          loading: _ctx.isLoading,
          "open-direction": 'bottom',
          onSearchChange: _ctx.onSearchChange,
          onOpen: _ctx.onOpen,
          onClose: _ctx.onClose
        }, {
          noResult: _withCtx(() => [
            _createTextVNode(" No results found ")
          ]),
          noOptions: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue", "options", "close-on-select", "preserve-search", "placeholder", "multiple", "disabled", "class", "loading", "onSearchChange", "onOpen", "onClose"])
      ])
    ], 2),
    (_ctx.validationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.validationError), 1))
      : _createCommentVNode("", true)
  ]))
}